export default "__VITE_ASSET__ChQ3HCdZ__"